import { COLORS } from '@btime/constants'
import { capitalizeAll } from '@btime/helpers'
import { compose, join, paths } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { WrapLoading } from '../../../components/helpers/Loading'
import {
  useCompleteServiceOrderRequest,
  usePauseServiceOrderRequest,
  useReasonPauseServiceOrderRequest,
  useUpdateServiceOrderRequest
} from './_requests/saveAndRedirects'
import { useIsEditing } from './_data/isEditing'
import { useIsPermalinkPage } from '../../../utils/session/permalinkToken'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import { useServiceOrder } from './_load/ServiceOrderLoader'
import FlexGrid from '../../../components/structure/FlexGrid'
import IconText from '../../../components/presentation/IconText'
import Link from '../../../components/actions/Link'
import PageHeaderPanel from '../../../components/presentation/PageHeaderPanel'
import { useSessionPermission } from '@btime/react-session'
import { useSaveReplies } from './_requests/saveServiceOrder'

const Action = ({ onClick, icon, label }) => (
  <Link block onClick={onClick}>
    <IconText iconSize="1.4rem" weight="700" iconName={icon} color={COLORS.white} label={label} noWrap />
  </Link>
)

const ResumePageHeader = () => {
  const { t } = useTranslation()
  const navigate = useNavigation()
  const serviceOrder = useServiceOrder()
  const isEditing = useIsEditing()
  const title = compose(capitalizeAll, join(' - '), paths([['yearlyId'], ['checklist', 'name']]))(serviceOrder)
  const requirePauseReason = useSessionPermission('requirePauseReason')

  const isPublic = useIsPermalinkPage()

  const [onComplete, completeState] = useCompleteServiceOrderRequest()
  const [onPause, pauseState] = usePauseServiceOrderRequest()
  // TODO: Think of a better way of solving this, today we are doing 2 requests: one to save replies and one to save pause with reason
  const [onSaveReplies, saveRepliesState] = useSaveReplies({ onSuccess: onPause })
  const [onReasonPause, reasonPauseState] = useReasonPauseServiceOrderRequest()
  const [onUpdate, updateState] = useUpdateServiceOrderRequest()

  const loading =
    completeState.loading ||
    (requirePauseReason ? pauseState.loading || saveRepliesState.loading : reasonPauseState.loading) ||
    updateState.loading

  const onReturn = () => {
    if (!!loading) return false
    if (isEditing) {
      navigate(`/service-orders/${serviceOrder.id}/resume`)
    } else {
      requirePauseReason ? onSaveReplies() : onReasonPause()
    }
  }

  return (
    <PageHeaderPanel
      leftIcon={!isPublic && 'BsArrowLeftShort'}
      leftAction={!isPublic && onReturn}
      title={title}
      mediumPadding
      noContainer
      side={
        <WrapLoading loading={loading} bgColor={COLORS.menu + '90'} color={COLORS.white}>
          <FlexGrid justify="flex-end" gutter={1}>
            {!isPublic && !isEditing && (
              <Action
                icon="BsStopwatch"
                label={t('pause')}
                onClick={requirePauseReason ? onSaveReplies : onReasonPause}
              />
            )}
            {!isEditing && <Action icon="BsCheckCircle" label={t('submit')} onClick={onComplete} />}
            {!!isEditing && <Action icon="BsCheckCircle" label={t('save')} onClick={onUpdate} />}
          </FlexGrid>
        </WrapLoading>
      }
    />
  )
}

export default ResumePageHeader
